module.exports = __webpack_public_path__ + "img/flower_white.77015f7d.svg";